import theme from 'src/theme';

export const energyConsumptionSx = {
    wrapper: {
        py: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        // The kit's phone rhythm: 12 between blocks. 24 is a third of a 390px screen spent on nothing.
        [theme.breakpoints.down('md')]: {
            py: '12px',
            gap: '12px',
        },
    },
    section: {
        bgcolor: theme.palette.common.white,
        borderRadius: '14px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.04)',
        p: 3,
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
        gap: 2,
        flexWrap: 'wrap',
    },
    sectionTitle: {
        fontSize: '1rem',
        fontWeight: 600,
        color: theme.palette.neutral[800],
        letterSpacing: '-0.01em',
    },
};
